export const curatedTypeDefs = `

scalar AWSDateTime

scalar AWSJSON

type Aggregation {
  _avg: Float!
  _max: Float!
  _min: Float!
  _p1: Float!
  _p5: Float!
  _p25: Float!
  _p50: Float!
  _p75: Float!
  _p95: Float!
  _p99: Float!
  _stdDev: Float!
  _sum: Float!
}

input BooleanFilterInput {
  _eq: Boolean
  _exists: Boolean
  _neq: Boolean
}

enum ContactEphemerisUsageType {
  DAILY_EPHEMERIS_REFRESH_POINTING_ANGLE
  DAILY_EPHEMERIS_REFRESH_VALIDATE_VISIBILITY
  FINAL_POINTING_ANGLE
  FINAL_POINTING_ANGLE_REFERENCE
  SCHEDULING
  UPDATE_CONTACT
}

input ContactEphemerisUsageTypeFilterInput {
  _eq: ContactEphemerisUsageType
  _exists: Boolean
  _in: [ContactEphemerisUsageType!]
  _neq: ContactEphemerisUsageType
  _nin: [ContactEphemerisUsageType!]
}

enum ContactStatus {
  AVAILABLE
  AWS_CANCELLED
  AWS_FAILED
  CANCELLED
  CANCELLING
  COMPLETED
  FAILED
  FAILED_TO_SCHEDULE
  PASS
  POSTPASS
  PREPASS
  RESCHEDULING
  SCHEDULED
  SCHEDULING
}

input ContactStatusFilterInput {
  _eq: ContactStatus
  _exists: Boolean
  _in: [ContactStatus!]
  _neq: ContactStatus
  _nin: [ContactStatus!]
}

type CursorPart {
  key: String!
  value: String!
}

input CursorPartInput {
  key: String!
  value: String!
}

type DataflowTranslation {
  egress: TranslationDetail
  ingress: TranslationDetail
}

input DataflowTranslationFilterInput {
  _and: [DataflowTranslationFilterInput!]
  _exists: Boolean
  _not: DataflowTranslationFilterInput
  _or: [DataflowTranslationFilterInput!]
  egress: TranslationDetailFilterInput
  ingress: TranslationDetailFilterInput
}

enum DeliveryMechanism {
  DDX
  LAMINAR_FLOW
}

input DeliveryMechanismFilterInput {
  _eq: DeliveryMechanism
  _exists: Boolean
  _in: [DeliveryMechanism!]
  _neq: DeliveryMechanism
  _nin: [DeliveryMechanism!]
}

type EphemerisInfo {
  """Unique identifier for the ephemeris"""
  ephemerisId: String!

  """Type of ephemeris"""
  ephemerisSourceType: EphemerisSourceType

  """Timestamp when the ephemeris was updated"""
  updateTime: AWSDateTime!

  """Type of ephemeris usage"""
  usageType: ContactEphemerisUsageType!
}

input EphemerisInfoFilterInput {
  _and: [EphemerisInfoFilterInput!]
  _exists: Boolean
  _not: EphemerisInfoFilterInput
  _or: [EphemerisInfoFilterInput!]
  ephemerisId: StringFilterInput
  ephemerisSourceType: EphemerisSourceTypeFilterInput
  updateTime: TimestampFilterInput
  usageType: ContactEphemerisUsageTypeFilterInput
}

enum EphemerisSourceType {
  AZ_EL
  OEM
  SERVICE_MANAGED
  TLE
}

input EphemerisSourceTypeFilterInput {
  _eq: EphemerisSourceType
  _exists: Boolean
  _in: [EphemerisSourceType!]
  _neq: EphemerisSourceType
  _nin: [EphemerisSourceType!]
}

input FloatFilterInput {
  _eq: Float
  _exists: Boolean
  _gt: Float
  _gte: Float
  _in: [Float!]
  _lt: Float
  _lte: Float
  _neq: Float
  _nin: [Float!]
}

input GetGsocContactV2Input {
  contactId: String
}

type GsocAntennaDemodDecodeDetails {
  decodeConfigData: GsocDecodeConfigData!
  demodulationConfigData: GsocDemodulationConfigData!
  rfCharacteristics: GsocRfCharacteristics!
}

input GsocAntennaDemodDecodeDetailsFilterInput {
  _and: [GsocAntennaDemodDecodeDetailsFilterInput!]
  _exists: Boolean
  _not: GsocAntennaDemodDecodeDetailsFilterInput
  _or: [GsocAntennaDemodDecodeDetailsFilterInput!]
  decodeConfigData: GsocDecodeConfigDataFilterInput
  demodulationConfigData: GsocDemodulationConfigDataFilterInput
  rfCharacteristics: GsocRfCharacteristicsFilterInput
}

type GsocAntennaDownlinkDetails {
  rfCharacteristics: GsocRfCharacteristics!
}

input GsocAntennaDownlinkDetailsFilterInput {
  _and: [GsocAntennaDownlinkDetailsFilterInput!]
  _exists: Boolean
  _not: GsocAntennaDownlinkDetailsFilterInput
  _or: [GsocAntennaDownlinkDetailsFilterInput!]
  rfCharacteristics: GsocRfCharacteristicsFilterInput
}

type GsocAwsTemporaryCredentials {
  accessKeyId: String!
  expiration: AWSDateTime!
  secretAccessKey: String!
  sessionToken: String!
}

type GsocCapabilityV2 {
  arn: String
  id: String!
  plots: [NamedImageV2!]!
  type: String!
}

input GsocCapabilityV2FilterInput {
  _and: [GsocCapabilityV2FilterInput!]
  _exists: Boolean
  _not: GsocCapabilityV2FilterInput
  _or: [GsocCapabilityV2FilterInput!]
  arn: StringFilterInput
  id: StringFilterInput
  plots: NamedImageV2FilterInput
  type: StringFilterInput
}

type GsocConfig {
  arn: String
  id: String!
  type: String!
}

input GsocConfigFilterInput {
  _and: [GsocConfigFilterInput!]
  _exists: Boolean
  _not: GsocConfigFilterInput
  _or: [GsocConfigFilterInput!]
  arn: StringFilterInput
  id: StringFilterInput
  type: StringFilterInput
}

type GsocConnectionProxyDetails {
  configArn: String
  dataflowTranslation: DataflowTranslation
}

input GsocConnectionProxyDetailsFilterInput {
  _and: [GsocConnectionProxyDetailsFilterInput!]
  _exists: Boolean
  _not: GsocConnectionProxyDetailsFilterInput
  _or: [GsocConnectionProxyDetailsFilterInput!]
  configArn: StringFilterInput
  dataflowTranslation: DataflowTranslationFilterInput
}

type GsocContactV2 {
  """Active contact version id for the contact"""
  activeContactVersionId: Int

  """ACU report"""
  acuPlots: S3Object @deprecated(reason: "Use contactPlots instead")

  """Unique identifier for the contact"""
  contactId: String!

  """Antenna-level postpass plots (ACU, VTR, etc.)"""
  contactPlots: [NamedImageV2!]

  """Current status of the contact."""
  contactStatus: ContactStatus!

  """Customer information for the contact."""
  customer: GsocCustomer!

  """List of dataflows and their detailed information"""
  dataflows: [GsocDataflowV2!]

  """time to live attribute"""
  datalakeTtl: AWSDateTime

  """List of regions where the contact data will land."""
  destinationRegions: [String!]!

  """Duration of the contact, in milliseconds"""
  durationMs: Float!

  """
  List storing EphemerisInfo objects storing info about the ephemeris used for scheduling, daily ephemeris refresh validate visibility or pointing angle, and reference/actual final pointing angle calculations
  """
  ephemerisInfoList: [EphemerisInfo!]

  """Failed to schedule reason"""
  failedToScheduleReasons: [String!]

  """
  AI-generated one-sentence explanation of why the contact failed. Only populated for contacts with status FAILED or AWS_FAILED. Best-effort — may be null if generation fails or contact is not in a failed state.
  """
  failureReason: String

  """Ground Stations."""
  groundStations: [GsocGroundStation!]

  """
  Configuration information from the Mission Profile at contact scheduling time.
  """
  missionProfile: GsocMissionProfile!

  """Unique identifier for the contact"""
  pk: String!

  """Satellite associated with the contact."""
  satellite: GsocSatellite

  """Region that the contact was scheduled from"""
  schedulingRegion: String!

  """
  Time at which the contact was scheduled (i.e. when the contact record was first created). Sourced from the control plane contact record's createTimestamp.
  """
  schedulingTime: AWSDateTime

  """
  Signature map containing troubleshooting information relevant to the contact.
  """
  signatureMap: [SignatureMapEntry!]

  """List of tags for tagging contacts for search purposes"""
  tags: [String!]

  """
  List of RouteIds created in CapTel Routing Service for telemetry delivery
  """
  telemetryRouteList: [String!]

  """The time range of the contact"""
  timeRange: TimeRange!
}

type GsocContactV2Aggregation {
  activeContactVersionId: Aggregation!
  durationMs: Aggregation!
  satellite: GsocSatelliteAggregation!
}

input GsocContactV2FilterInput {
  _and: [GsocContactV2FilterInput!]
  _exists: Boolean
  _not: GsocContactV2FilterInput
  _or: [GsocContactV2FilterInput!]
  activeContactVersionId: IntegerFilterInput
  acuPlots: S3ObjectFilterInput
  contactId: StringFilterInput
  contactPlots: NamedImageV2FilterInput
  contactStatus: ContactStatusFilterInput
  customer: GsocCustomerFilterInput
  dataflows: GsocDataflowV2FilterInput
  datalakeTtl: TimestampFilterInput
  destinationRegions: StringFilterInput
  durationMs: FloatFilterInput
  ephemerisInfoList: EphemerisInfoFilterInput
  failedToScheduleReasons: StringFilterInput
  failureReason: StringFilterInput
  groundStations: GsocGroundStationFilterInput
  missionProfile: GsocMissionProfileFilterInput
  pk: StringFilterInput
  satellite: GsocSatelliteFilterInput
  schedulingRegion: StringFilterInput
  schedulingTime: TimestampFilterInput
  signatureMap: SignatureMapFilterInput
  tags: StringFilterInput
  telemetryRouteList: StringFilterInput
  timeRange: TimeRangeFilterInput
}

input GsocContactV2SortInput {
  activeContactVersionId: SortOrder
  acuPlots: S3ObjectSortInput
  contactId: SortOrder
  contactStatus: SortOrder
  customer: GsocCustomerSortInput
  datalakeTtl: SortOrder
  durationMs: SortOrder
  failureReason: SortOrder
  missionProfile: GsocMissionProfileSortInput
  pk: SortOrder
  satellite: GsocSatelliteSortInput
  schedulingRegion: SortOrder
  schedulingTime: SortOrder
  timeRange: TimeRangeSortInput
}

type GsocCustomer {
  awsAccountId: String
  awsGsaasAwsAccountNamePart: String!
  external: Boolean!
}

input GsocCustomerFilterInput {
  _and: [GsocCustomerFilterInput!]
  _exists: Boolean
  _not: GsocCustomerFilterInput
  _or: [GsocCustomerFilterInput!]
  awsAccountId: StringFilterInput
  awsGsaasAwsAccountNamePart: StringFilterInput
  external: BooleanFilterInput
}

input GsocCustomerSortInput {
  awsAccountId: SortOrder
  awsGsaasAwsAccountNamePart: SortOrder
  external: SortOrder
}

type GsocDataflowV2 {
  dataflowId: String!
  destination: GsocNodeV2!
  source: GsocNodeV2!
  tags: [String!]!
}

input GsocDataflowV2FilterInput {
  _and: [GsocDataflowV2FilterInput!]
  _exists: Boolean
  _not: GsocDataflowV2FilterInput
  _or: [GsocDataflowV2FilterInput!]
  dataflowId: StringFilterInput
  destination: GsocNodeV2FilterInput
  source: GsocNodeV2FilterInput
  tags: StringFilterInput
}

enum GsocDataplaneType {
  DATA_DEFENDER
  LAMINAR_FLOW
}

input GsocDataplaneTypeFilterInput {
  _eq: GsocDataplaneType
  _exists: Boolean
  _in: [GsocDataplaneType!]
  _neq: GsocDataplaneType
  _nin: [GsocDataplaneType!]
}

type GsocDecodeConfigData {
  unvalidatedJson: String!
}

input GsocDecodeConfigDataFilterInput {
  _and: [GsocDecodeConfigDataFilterInput!]
  _exists: Boolean
  _not: GsocDecodeConfigDataFilterInput
  _or: [GsocDecodeConfigDataFilterInput!]
  unvalidatedJson: StringFilterInput
}

type GsocDemodulationConfigData {
  unvalidatedJson: String!
}

input GsocDemodulationConfigDataFilterInput {
  _and: [GsocDemodulationConfigDataFilterInput!]
  _exists: Boolean
  _not: GsocDemodulationConfigDataFilterInput
  _or: [GsocDemodulationConfigDataFilterInput!]
  unvalidatedJson: StringFilterInput
}

type GsocGroundStation {
  antennaName: String
  groundStationId: String!
  groundStationName: String!
  region: String!
}

input GsocGroundStationFilterInput {
  _and: [GsocGroundStationFilterInput!]
  _exists: Boolean
  _not: GsocGroundStationFilterInput
  _or: [GsocGroundStationFilterInput!]
  antennaName: StringFilterInput
  groundStationId: StringFilterInput
  groundStationName: StringFilterInput
  region: StringFilterInput
}

type GsocIamRole {
  awsTemporaryCredentials: GsocAwsTemporaryCredentials
  isAuthorized: Boolean!
  name: String!
  roleArn: String!
}

type GsocIntegerRange {
  maximum: Int!
  minimum: Int!
}

input GsocIntegerRangeFilterInput {
  _and: [GsocIntegerRangeFilterInput!]
  _exists: Boolean
  _not: GsocIntegerRangeFilterInput
  _or: [GsocIntegerRangeFilterInput!]
  maximum: IntegerFilterInput
  minimum: IntegerFilterInput
}

type GsocListIamRolesOutput {
  roles: [GsocIamRole!]!
}

type GsocManagedAntennaDemodDecodeDetails {
  managedRadioConfigId: String!
  rfCharacteristics: GsocRfCharacteristics!
}

input GsocManagedAntennaDemodDecodeDetailsFilterInput {
  _and: [GsocManagedAntennaDemodDecodeDetailsFilterInput!]
  _exists: Boolean
  _not: GsocManagedAntennaDemodDecodeDetailsFilterInput
  _or: [GsocManagedAntennaDemodDecodeDetailsFilterInput!]
  managedRadioConfigId: StringFilterInput
  rfCharacteristics: GsocRfCharacteristicsFilterInput
}

type GsocMissionProfile {
  missionProfileArn: String
  missionProfileId: String!
  missionProfileName: String
}

input GsocMissionProfileFilterInput {
  _and: [GsocMissionProfileFilterInput!]
  _exists: Boolean
  _not: GsocMissionProfileFilterInput
  _or: [GsocMissionProfileFilterInput!]
  missionProfileArn: StringFilterInput
  missionProfileId: StringFilterInput
  missionProfileName: StringFilterInput
}

input GsocMissionProfileSortInput {
  missionProfileArn: SortOrder
  missionProfileId: SortOrder
  missionProfileName: SortOrder
}

type GsocNodeAgentDetails {
  version: String
}

input GsocNodeAgentDetailsFilterInput {
  _and: [GsocNodeAgentDetailsFilterInput!]
  _exists: Boolean
  _not: GsocNodeAgentDetailsFilterInput
  _or: [GsocNodeAgentDetailsFilterInput!]
  version: StringFilterInput
}

type GsocNodeDataplaneDataDefenderDetails {
  dataDeliveryServiceDestinationArn: String
  dataDeliveryServiceSourceArn: String
  securityDetails: GsocSecurityDetails
  vita49StreamId: Int
}

input GsocNodeDataplaneDataDefenderDetailsFilterInput {
  _and: [GsocNodeDataplaneDataDefenderDetailsFilterInput!]
  _exists: Boolean
  _not: GsocNodeDataplaneDataDefenderDetailsFilterInput
  _or: [GsocNodeDataplaneDataDefenderDetailsFilterInput!]
  dataDeliveryServiceDestinationArn: StringFilterInput
  dataDeliveryServiceSourceArn: StringFilterInput
  securityDetails: GsocSecurityDetailsFilterInput
  vita49StreamId: IntegerFilterInput
}

type GsocNodeDataplaneDetails {
  dataDefender: GsocNodeDataplaneDataDefenderDetails
  dataflowType: GsocDataplaneType
  laminarFlow: GsocNodeDataplaneLaminarFlowDetails
}

input GsocNodeDataplaneDetailsFilterInput {
  _and: [GsocNodeDataplaneDetailsFilterInput!]
  _exists: Boolean
  _not: GsocNodeDataplaneDetailsFilterInput
  _or: [GsocNodeDataplaneDetailsFilterInput!]
  dataDefender: GsocNodeDataplaneDataDefenderDetailsFilterInput
  dataflowType: GsocDataplaneTypeFilterInput
  laminarFlow: GsocNodeDataplaneLaminarFlowDetailsFilterInput
}

type GsocNodeDataplaneLaminarFlowDetails {
  agent: GsocNodeAgentDetails
  egressAddress: GsocRangedConnectionDetails
  ingressAddress: GsocRangedConnectionDetails
  laminarflowConfig: String
  vita49StreamId: Int
}

input GsocNodeDataplaneLaminarFlowDetailsFilterInput {
  _and: [GsocNodeDataplaneLaminarFlowDetailsFilterInput!]
  _exists: Boolean
  _not: GsocNodeDataplaneLaminarFlowDetailsFilterInput
  _or: [GsocNodeDataplaneLaminarFlowDetailsFilterInput!]
  agent: GsocNodeAgentDetailsFilterInput
  egressAddress: GsocRangedConnectionDetailsFilterInput
  ingressAddress: GsocRangedConnectionDetailsFilterInput
  laminarflowConfig: StringFilterInput
  vita49StreamId: IntegerFilterInput
}

type GsocNodeDetails {
  dataplane: GsocNodeDataplaneDetails
  orchestration: GsocNodeOrchestrationDetails
}

input GsocNodeDetailsFilterInput {
  _and: [GsocNodeDetailsFilterInput!]
  _exists: Boolean
  _not: GsocNodeDetailsFilterInput
  _or: [GsocNodeDetailsFilterInput!]
  dataplane: GsocNodeDataplaneDetailsFilterInput
  orchestration: GsocNodeOrchestrationDetailsFilterInput
}

type GsocNodeOrchestrationDetails {
  antennaDemodDecodeDetails: GsocAntennaDemodDecodeDetails
  antennaDownlinkDetails: GsocAntennaDownlinkDetails
  connectionProxyDetails: GsocConnectionProxyDetails
  managedAntennaDemodDecodeDetails: GsocManagedAntennaDemodDecodeDetails
  s3PlaybackDetails: GsocS3PlaybackDetails
  s3RecordingDetails: GsocS3RecordingDetails
  uplinkDetails: GsocUplinkDetails
  uplinkEchoDetails: GsocUplinkEchoDetails
}

input GsocNodeOrchestrationDetailsFilterInput {
  _and: [GsocNodeOrchestrationDetailsFilterInput!]
  _exists: Boolean
  _not: GsocNodeOrchestrationDetailsFilterInput
  _or: [GsocNodeOrchestrationDetailsFilterInput!]
  antennaDemodDecodeDetails: GsocAntennaDemodDecodeDetailsFilterInput
  antennaDownlinkDetails: GsocAntennaDownlinkDetailsFilterInput
  connectionProxyDetails: GsocConnectionProxyDetailsFilterInput
  managedAntennaDemodDecodeDetails: GsocManagedAntennaDemodDecodeDetailsFilterInput
  s3PlaybackDetails: GsocS3PlaybackDetailsFilterInput
  s3RecordingDetails: GsocS3RecordingDetailsFilterInput
  uplinkDetails: GsocUplinkDetailsFilterInput
  uplinkEchoDetails: GsocUplinkEchoDetailsFilterInput
}

type GsocNodeV2 {
  capability: GsocCapabilityV2!
  config: GsocConfig!
  nodeDetails: GsocNodeDetails!
  region: String!
  telemetryInfo: GsocTelemetryInformation
}

input GsocNodeV2FilterInput {
  _and: [GsocNodeV2FilterInput!]
  _exists: Boolean
  _not: GsocNodeV2FilterInput
  _or: [GsocNodeV2FilterInput!]
  capability: GsocCapabilityV2FilterInput
  config: GsocConfigFilterInput
  nodeDetails: GsocNodeDetailsFilterInput
  region: StringFilterInput
  telemetryInfo: GsocTelemetryInformationFilterInput
}

type GsocRangedConnectionDetails {
  name: String
  portRange: GsocIntegerRange!
}

input GsocRangedConnectionDetailsFilterInput {
  _and: [GsocRangedConnectionDetailsFilterInput!]
  _exists: Boolean
  _not: GsocRangedConnectionDetailsFilterInput
  _or: [GsocRangedConnectionDetailsFilterInput!]
  name: StringFilterInput
  portRange: GsocIntegerRangeFilterInput
}

type GsocRfCharacteristics {
  """Bandwidth is not present during uplink or uplink echo."""
  bandwidth: Measurement
  centerFrequency: Measurement!
  polarization: Polarization!
}

input GsocRfCharacteristicsFilterInput {
  _and: [GsocRfCharacteristicsFilterInput!]
  _exists: Boolean
  _not: GsocRfCharacteristicsFilterInput
  _or: [GsocRfCharacteristicsFilterInput!]
  bandwidth: MeasurementFilterInput
  centerFrequency: MeasurementFilterInput
  polarization: PolarizationFilterInput
}

type GsocS3PlaybackDetails {
  bucketArn: String
  bucketRegion: String!
  keys: [String!]
  roleArn: String
}

input GsocS3PlaybackDetailsFilterInput {
  _and: [GsocS3PlaybackDetailsFilterInput!]
  _exists: Boolean
  _not: GsocS3PlaybackDetailsFilterInput
  _or: [GsocS3PlaybackDetailsFilterInput!]
  bucketArn: StringFilterInput
  bucketRegion: StringFilterInput
  keys: StringFilterInput
  roleArn: StringFilterInput
}

type GsocS3RecordingDetails {
  bucketArn: String
  bucketRegion: String!
  keyTemplate: String
  roleArn: String
}

input GsocS3RecordingDetailsFilterInput {
  _and: [GsocS3RecordingDetailsFilterInput!]
  _exists: Boolean
  _not: GsocS3RecordingDetailsFilterInput
  _or: [GsocS3RecordingDetailsFilterInput!]
  bucketArn: StringFilterInput
  bucketRegion: StringFilterInput
  keyTemplate: StringFilterInput
  roleArn: StringFilterInput
}

type GsocSatellite {
  """Customer owning this satellite"""
  customer: GsocCustomer!

  """AWS Satellite Resource ID"""
  id: String

  """Satellite Arn"""
  satelliteArn: String

  """Satellite Catalog Number"""
  satelliteCatalogNumber: Int

  """Satellite Name"""
  satelliteName: String

  """List of tags for tagging satellites for search purposes"""
  tags: [String!]
}

type GsocSatelliteAggregation {
  satelliteCatalogNumber: Aggregation!
}

input GsocSatelliteFilterInput {
  _and: [GsocSatelliteFilterInput!]
  _exists: Boolean
  _not: GsocSatelliteFilterInput
  _or: [GsocSatelliteFilterInput!]
  customer: GsocCustomerFilterInput
  id: StringFilterInput
  satelliteArn: StringFilterInput
  satelliteCatalogNumber: IntegerFilterInput
  satelliteName: StringFilterInput
  tags: StringFilterInput
}

input GsocSatelliteSortInput {
  customer: GsocCustomerSortInput
  id: SortOrder
  satelliteArn: SortOrder
  satelliteCatalogNumber: SortOrder
  satelliteName: SortOrder
}

type GsocSecurityDetails {
  roleArn: String
  securityGroupIds: [String!]!
  subnetIds: [String!]!
}

input GsocSecurityDetailsFilterInput {
  _and: [GsocSecurityDetailsFilterInput!]
  _exists: Boolean
  _not: GsocSecurityDetailsFilterInput
  _or: [GsocSecurityDetailsFilterInput!]
  roleArn: StringFilterInput
  securityGroupIds: StringFilterInput
  subnetIds: StringFilterInput
}

type GsocTelemetryInformation {
  telemetryScopeId: String!
  telemetrySourceArn: String!
}

input GsocTelemetryInformationFilterInput {
  _and: [GsocTelemetryInformationFilterInput!]
  _exists: Boolean
  _not: GsocTelemetryInformationFilterInput
  _or: [GsocTelemetryInformationFilterInput!]
  telemetryScopeId: StringFilterInput
  telemetrySourceArn: StringFilterInput
}

type GsocUplinkDetails {
  rfCharacteristics: GsocRfCharacteristics!
  targetEirp: Measurement!
  transmitDisabled: Boolean!
}

input GsocUplinkDetailsFilterInput {
  _and: [GsocUplinkDetailsFilterInput!]
  _exists: Boolean
  _not: GsocUplinkDetailsFilterInput
  _or: [GsocUplinkDetailsFilterInput!]
  rfCharacteristics: GsocRfCharacteristicsFilterInput
  targetEirp: MeasurementFilterInput
  transmitDisabled: BooleanFilterInput
}

type GsocUplinkEchoDetails {
  enabled: Boolean!
  rfCharacteristics: GsocRfCharacteristics!
}

input GsocUplinkEchoDetailsFilterInput {
  _and: [GsocUplinkEchoDetailsFilterInput!]
  _exists: Boolean
  _not: GsocUplinkEchoDetailsFilterInput
  _or: [GsocUplinkEchoDetailsFilterInput!]
  enabled: BooleanFilterInput
  rfCharacteristics: GsocRfCharacteristicsFilterInput
}

input IntegerFilterInput {
  _eq: Int
  _exists: Boolean
  _gt: Int
  _gte: Int
  _in: [Int!]
  _lt: Int
  _lte: Int
  _neq: Int
  _nin: [Int!]
}

input ListGsocContactV2Input {
  cursor: [CursorPartInput!]
  limit: Int = 10
  sort: [GsocContactV2SortInput!]
  where: GsocContactV2FilterInput
}

type ListGsocContactV2Output {
  aggregations: GsocContactV2Aggregation!
  pageInfo: PageInfo!
  results: [GsocContactV2!]!
}

type Measurement {
  unit: String!
  value: Float!
}

input MeasurementFilterInput {
  _and: [MeasurementFilterInput!]
  _exists: Boolean
  _not: MeasurementFilterInput
  _or: [MeasurementFilterInput!]
  unit: StringFilterInput
  value: FloatFilterInput
}

type NamedImage {
  imageBase64: String!
  name: String!
}

type NamedImageV2 {
  """Interactive HTML version of this plot, if available"""
  htmlImage: S3Object
  image: S3Object!
  name: String!
}

input NamedImageV2FilterInput {
  _and: [NamedImageV2FilterInput!]
  _exists: Boolean
  _not: NamedImageV2FilterInput
  _or: [NamedImageV2FilterInput!]
  htmlImage: S3ObjectFilterInput
  image: S3ObjectFilterInput
  name: StringFilterInput
}

type PageInfo {
  hasNextPage: Boolean!
  lastCursor: [CursorPart!]
  total: Total!
}

enum Polarization {
  BOTH
  LEFT_HAND
  NONE
  RIGHT_HAND
}

input PolarizationFilterInput {
  _eq: Polarization
  _exists: Boolean
  _in: [Polarization!]
  _neq: Polarization
  _nin: [Polarization!]
}

type Query {
  getGsocContactV2(cazJustification: String, input: GetGsocContactV2Input!): GsocContactV2
  getUserPermissionClaims: [String!]!
  gsocListIamRoles(cazJustification: String): GsocListIamRolesOutput
  listGsocContactV2(cazJustification: String, input: ListGsocContactV2Input!): ListGsocContactV2Output
}

enum Relation {
  eq
  gte
}

type S3Object {
  presignedUrl: String!
  s3Uri: String!
}

input S3ObjectFilterInput {
  _and: [S3ObjectFilterInput!]
  _exists: Boolean
  _not: S3ObjectFilterInput
  _or: [S3ObjectFilterInput!]
  s3Uri: StringFilterInput
}

input S3ObjectSortInput {
  s3Uri: SortOrder
}

type SignatureMapEntry {
  key: String
  value: Boolean
}

input SignatureMapFilterInput {
  _and: [SignatureMapFilterInput!]
  _exists: Boolean
  _not: SignatureMapFilterInput
  _or: [SignatureMapFilterInput!]
  key: StringFilterInput
  value: BooleanFilterInput
}

enum SortOrder {
  asc
  desc
}

input StringFilterInput {
  _eq: String
  _exists: Boolean
  _gt: String
  _gte: String
  _in: [String!]
  _lt: String
  _lte: String
  _neq: String
  _nin: [String!]
  _startsWith: String
}

type TimeRange {
  endTime: AWSDateTime!
  startTime: AWSDateTime!
}

input TimeRangeFilterInput {
  _and: [TimeRangeFilterInput!]
  _exists: Boolean
  _not: TimeRangeFilterInput
  _or: [TimeRangeFilterInput!]
  endTime: TimestampFilterInput
  startTime: TimestampFilterInput
}

input TimeRangeSortInput {
  endTime: SortOrder
  startTime: SortOrder
}

input TimestampFilterInput {
  _eq: AWSDateTime
  _exists: Boolean
  _gt: AWSDateTime
  _gte: AWSDateTime
  _in: [AWSDateTime!]
  _lt: AWSDateTime
  _lte: AWSDateTime
  _neq: AWSDateTime
  _nin: [AWSDateTime!]
}

type Total {
  relation: Relation
  value: Int
}

type TranslationConfiguration {
  laminarFlowConfig: String
  type: DeliveryMechanism
  vpcAttachmentDetails: VpcAttachmentDetails
}

input TranslationConfigurationFilterInput {
  _and: [TranslationConfigurationFilterInput!]
  _exists: Boolean
  _not: TranslationConfigurationFilterInput
  _or: [TranslationConfigurationFilterInput!]
  laminarFlowConfig: StringFilterInput
  type: DeliveryMechanismFilterInput
  vpcAttachmentDetails: VpcAttachmentDetailsFilterInput
}

type TranslationDetail {
  deliveryMechanism: DeliveryMechanism
  translationConfiguration: TranslationConfiguration
}

input TranslationDetailFilterInput {
  _and: [TranslationDetailFilterInput!]
  _exists: Boolean
  _not: TranslationDetailFilterInput
  _or: [TranslationDetailFilterInput!]
  deliveryMechanism: DeliveryMechanismFilterInput
  translationConfiguration: TranslationConfigurationFilterInput
}

type VpcAttachmentDetails {
  customerRoleArn: String
  dataflowEndpointGroupArn: String
  securityGroupIdList: [String!]
  subnetIdList: [String!]
}

input VpcAttachmentDetailsFilterInput {
  _and: [VpcAttachmentDetailsFilterInput!]
  _exists: Boolean
  _not: VpcAttachmentDetailsFilterInput
  _or: [VpcAttachmentDetailsFilterInput!]
  customerRoleArn: StringFilterInput
  dataflowEndpointGroupArn: StringFilterInput
  securityGroupIdList: StringFilterInput
  subnetIdList: StringFilterInput
}
`;
